/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name cellday
 */
angular.module('mercury.modules.time.roster')
.directive('cellday', ["reporttime", "$stateParams", function(reporttime, $stateParams) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element) {
      if (!scope.isTemplate) {
        // If the cell has to be disabled because the roster that the cell belongs
        // to is published then we don't want the day-row class and we also don't
        // want the user to be able to click on the cell and keep adding/updating
        // shifts
        //
        // Note templates are always editable.
        var cellIsDisabled = scope.disableCell(scope.viewStartDateTime);
        if (cellIsDisabled) {
          element.removeClass('day-row');
          return;
        }
      }

      element.droppable({
        multiple: true,
        classes: {
          'ui-droppable-hover': 'ui-state-hover'
        },
        over: function(event, ui) {
          ui.draggable.data('staffId', scope.member.id);
        },
        drop: function(event, ui) {
          // Snap the draggable to the cell.
          $(ui.draggable).detach().appendTo(this);
        }
      });

      var roundMinutes = function(input) {
        var interval = 15;
        return Math.round(input / interval) * interval;
      };

      var MINUTES_PER_DAY = 1440;

      var addShiftStart = null;
      var startClientXPos = null;
      scope.placeholderStyle = null;

      /**
       * A mouse down was registered on the day row. We don't know if this is a proper add shift action but set the needed
       * scope variables
       */
      element.on('mousedown', function(e) {
        //Undefined on firefox
        if (typeof e.offsetX == 'undefined') {
          addShiftStart = e.clientX - angular.element(e.currentTarget).parent().context.offsetLeft;
        } else {
          addShiftStart = e.offsetX;
        }

        // Only trigger the drag to create if the editor cell was the event target.
        // Note that this will prevent dragging to create a shift if the user tries
        // to drag over the top of a unavailability block. This inconvience is
        // desirable, the user instead needs to click the cell to schedule over
        // the unavailability if they really want to roster for a period the staff
        // member has said they aren't able to work.
        if (angular.element(e.target).hasClass('day-row') === false) {
          return;
        }

        startClientXPos = e.clientX;

        scope.placeholderStyle = {
          left: addShiftStart + 'px',
          width: '0px'
        };
      });

      /**
       * If a mouse down but no mouse up, update the placeholder width to show the current width of the new shift
       */
      element.on('mousemove', function(e) {
        if (scope.placeholderStyle) {
          scope.placeholderStyle.width = e.clientX - startClientXPos + 'px';
        }
      });

      /**
       * If a long enough difference between mouse down position and mouse up positon, add a shift
       * based on the fraction of movement along the row.
       * If the difference isn't long enough, open the shift editor to add a new shift.
       */
      element.on('mouseup', function(e) {
        var startMinutes = roundMinutes(MINUTES_PER_DAY * (addShiftStart / angular.element(e.currentTarget).width()));
        if (scope.placeholderStyle) {
          var lengthMinutes = roundMinutes(MINUTES_PER_DAY * ((e.clientX - startClientXPos) / angular.element(e.currentTarget).width()));

          var endMinutes = startMinutes + lengthMinutes;

          var startTime = moment(scope.viewStartDateTime).add(startMinutes, 'minutes');
          var endTime = moment(scope.viewStartDateTime).add(endMinutes, 'minutes');

          // If the user has dragged for at least 15 minutes on the day view we
          // create a new shift and add this to the roster.
          if (startMinutes != endMinutes && endMinutes - startMinutes >= 15) {
            var newShift = {
              roleId: scope.member.defaultMemberRoleRoleId,
              roleName: scope.member.defaultMemberRoleRoleName,
              staffMemberId: scope.member.id,
              clockinTime: startTime.format(),
              clockoutTime: endTime.format(),
              breaks: [],
              saving: true,
              rosterId: $stateParams.templateId
            };
            
            scope.createShift(newShift);
          } else if (
            angular.element(e.target).hasClass('day-row') ||
            angular.element(e.target).hasClass('day-shift')
          ) {
            scope.openEditDialog({
              shifts: {
                roleId: scope.member.defaultMemberRoleRoleId,
                roleName: scope.member.defaultMemberRoleRoleName,
                staffMemberId: scope.member.id,
                clockinTime: moment(scope.viewStartDateTime).add(startMinutes, 'minutes').format(),
                clockoutTime: moment(scope.viewStartDateTime).add(startMinutes + 180, 'minutes').format(),
                breaks: [],
                rosterId: $stateParams.templateId
              },
              staff: scope.staff,
              roles: scope.roles,
              saveCb: scope.save
            });
          }
        }

        addShiftStart = null;
        scope.placeholderStyle = null;
      });
    }
  };
}]);
